"use client"

import { useRouter, usePathname } from "next/navigation"
import Link from "next/link"
import { ReactNode } from "react"

interface SmartAnchorLinkProps {
  href: string
  children: ReactNode
  className?: string
  onClick?: () => void
}

export function SmartAnchorLink({ href, children, className, onClick }: SmartAnchorLinkProps) {
  const router = useRouter()
  const pathname = usePathname()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // 如果有自定义的onClick处理函数，先执行它
    if (onClick) {
      onClick()
    }

    // 检查是否是锚点链接（以#开头）
    if (href.startsWith('#')) {
      e.preventDefault()
      
      // 如果当前不在主页面，先跳转到主页面，然后滚动到锚点
      if (pathname !== '/') {
        // 跳转到主页面并带上锚点
        router.push(`/${href}`)
      } else {
        // 如果已经在主页面，直接滚动到锚点
        const element = document.querySelector(href)
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          })
        }
      }
    }
    // 如果不是锚点链接，让Link组件正常处理
  }

  return (
    <Link 
      href={href.startsWith('#') && pathname !== '/' ? `/${href}` : href}
      className={className}
      onClick={handleClick}
    >
      {children}
    </Link>
  )
} 